const ID_KEY = 'karaokr_event_user_id';
const NAME_KEY = 'karaokr_event_user_name';
const AVATAR_KEY = 'karaokr_event_user_avatar';
const EMAIL_KEY = 'karaokr_event_user_email';

export interface Identity {
  id: string;
  name: string;
  avatarUrl: string;
  email?: string;
}

export function getOrCreateIdentity(): Identity {
  let id = localStorage.getItem(ID_KEY);
  let name = localStorage.getItem(NAME_KEY);
  let avatarUrl = localStorage.getItem(AVATAR_KEY);
  let email = localStorage.getItem(EMAIL_KEY);
  if (!id) {
    id = `user-${Math.random().toString(36).substring(2, 10)}`;
    localStorage.setItem(ID_KEY, id);
  }
  return { id, name: name || '', avatarUrl: avatarUrl || '', email: email || undefined };
}

export function setIdentityName(name: string) {
  localStorage.setItem(NAME_KEY, name);
}

export function setIdentityAvatar(avatarUrl: string) {
  localStorage.setItem(AVATAR_KEY, avatarUrl);
}

export function setIdentityEmail(email: string) {
  localStorage.setItem(EMAIL_KEY, email);
}

export function setIdentity(identity: Identity) {
  localStorage.setItem(ID_KEY, identity.id);
  if (identity.name) localStorage.setItem(NAME_KEY, identity.name);
  if (identity.avatarUrl) localStorage.setItem(AVATAR_KEY, identity.avatarUrl);
  if (identity.email) localStorage.setItem(EMAIL_KEY, identity.email);
}

export function clearIdentity() {
  localStorage.removeItem(NAME_KEY);
  localStorage.removeItem(AVATAR_KEY);
  localStorage.removeItem(EMAIL_KEY);
}
